/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, bool, func } from 'prop-types';
import classNames from 'clsx';
import Autocomplete from 'react-google-autocomplete';

import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './google-places-input.scss';

/**
 * This is the GooglePlacesInput component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class GooglePlacesInput extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    name: string.isRequired,
    placeholder: string,
    value: string,
    required: bool,
    disabled: bool,
    readOnly: bool,
    error: bool,
    onFocus: func,
    onBlur: func,
    onChange: func,
  };

  static defaultProps = {
    placeholder: '',
    value: '',
    required: false,
    error: false,
    disabled: false,
    readOnly: false,
    large: false,
    compact: false,
    onFocus: () => {},
    onBlur: () => {},
    onChange: () => {},
  };

  componentDidMount() {
    // Only query the fields we need.
    // https://github.com/ErrorPro/react-google-autocomplete/issues/36
    this.input.autocomplete.setFields(['formatted_address']);
  }

  onPlaceSelected = place => {
    const { onChange } = this.props;
    const { formatted_address } = place;

    // We manipulute the onChangeHandler
    // in Input so it thinks it gets an input.
    onChange({
      target: {
        value: formatted_address,
      },
    });
  };

  onKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  };

  /**
   * Render GooglePlacesInput.
   *
   * @return {Object}
   */
  render() {
    const {
      name,
      value,
      placeholder,
      error,
      required,
      disabled,
      readOnly,
      onChange,
      onBlur,
      onFocus,
    } = this.props;

    return (
      <div className={styles.wrapper}>
        <Autocomplete
          className={classNames(styles.input, {
            [styles.error]: error,
          })}
          ref={ref => {
            this.input = ref;
          }}
          types={['(regions)']}
          onKeyDown={this.onKeyDown}
          onPlaceSelected={this.onPlaceSelected}
          {...{
            name,
            value,
            placeholder,
            required,
            disabled,
            readOnly,
            onBlur,
            onFocus,
            onChange,
          }}
        />

        <span className={styles.arrow}>
          <BlackTieIcon icon="caret-up" small />
          <BlackTieIcon icon="caret-down" small />
        </span>
      </div>
    );
  }
}
